import Model from '@/models/search'

export default {
    namespaced:true,
    state:{
        list:[],
        total:0
    },
    getters:{
        getTable(state){
            return state.list
        },
        getTotal(state){
            return state.total
        }
    },
    mutations:{
        setTable(state,{data}){
            if(data.success){
                state.list=data.list;
                state.total=data.pagination.total;
            }
        },
    },
    actions:{
        async setTableAction({commit},payload){
            commit('setTable',await Model.getTable(payload))
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/search.js